/** Browser-level MCP endpoint health probe. */

import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getAgentEndpoints } from '../lib/agent-endpoints'

export type McpHealthStatus = 'ready' | 'unreachable'

function mcpHealthUrl(endpoint: string) {
  const url = new URL(endpoint)
  url.pathname = '/health'
  url.search = ''
  url.hash = ''
  return url.toString()
}

export function useMcpHealth() {
  const endpoints = useMemo(() => getAgentEndpoints(), [])
  const healthUrl = useMemo(() => mcpHealthUrl(endpoints.mcp), [endpoints.mcp])

  return useQuery<{ status: McpHealthStatus; endpoint: string; checkedAt: number }>({
    queryKey: ['mcp-health', healthUrl],
    queryFn: async () => {
      const response = await fetch(healthUrl, { cache: 'no-store', mode: 'no-cors' })
      if (response.type !== 'opaque' && !response.ok)
        throw new Error(`MCP health returned ${response.status}`)
      return { status: 'ready', endpoint: endpoints.mcp, checkedAt: Date.now() }
    },
    retry: 1,
    staleTime: 1000 * 30,
  })
}
